// src/utils/fcmHelpers.js
import { getToken } from "firebase/messaging";
import { messaging } from "../firebase/firebase";

export const getFCMTokenAfterLogin = async () => {
  if (!messaging) return null;

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    console.warn("Notification permission not granted");
    return null;
  }

  try {
    const token = await getToken(messaging, {
      vapidKey:
        "BM34vF-V6aEzM5brBik8-05eOMCUi3eXf2OKzLWt0LKGmATnch3C-dNYd6hMGo7wH6q-MzgbmifI7XTX5A12RZ4", // From Firebase Console > Cloud Messaging
    });

    console.log("FCM Token:", token);
    return token;
  } catch (err) {
    console.error("FCM token error", err);
    return null;
  }
};
